export default {
	"transSec.FailedToGetPaymentLink": "獲取支付鏈接失敗",
	"transSec.IDidntGetAPaymentToken": "沒獲取到支付token",
	"transSec.FailedToCreateAlipayPrepaidOrder": "創建支付寶預付單失敗！",
	"transSec.FailedToGetPaymentInformation": "獲取支付信息失敗",
	"transSec.return": "返回",
	"transSec.AgreeAndContinue": "同意並繼續",
	"transSec.NoProductsSelected": "未選擇商品",
	"transSec.prompt": "提示",
	"transSec.UntieTheBindingForTheTimeBeing": "暫不解綁",
	"transSec.UnbindTheAccount": "解綁帳號",
	"transSec.SorryThePriceHasChanged": "抱歉，價格已發生變化！",
	"transSec.SorryFailedToCreateOrder": "抱歉，創建訂單失敗！",
	"transSec.RepeatPurchasePrompts": "重複購買提示",
	"transSec.ignore": "忽略",
	"transSec.ViewOrders": "查看訂單",
	"transSec.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization": "微信授權後可進入訪問，請求授權中···",
	"transSec.MarketplaceConfirmOrderPagePaymentMethodClick": "商城確認訂單頁_支付方式點擊",
	"transSec.MarketplaceafterAddress": "商城（位址後置）",
	"transSec.MarketplaceCashierPageOrderButton": "商城收銀台頁_下單按鈕",
	"transSec.TheSystemIsDeserting": "系統開小差啦",
	"transSec.TheSystemIsDesertingPleaseTryAgainLater": "系統開小差啦，請稍後再試",
	"transSec.PaymentFailed": "支付失敗！",
	"transSec.PaymentSuccessful": "支付成功",
	"transSec.PaidSuccessfullyJumping": "已支付成功，正在跳轉中...",
	"transSec.Wechat": "微信",
	"transSec.FlowerStaging": "花唄分期",
	"transSec.AlipayScanCodeToPay": "支付寶掃碼支付",
	"transSec.PleaseTryAgainIfTheQueryFails": "查詢失敗請重試",
	"transSec.IfThePaymentIsSuccessfulPleaseReturnToWeChatToContinueTheOperation": "支付成功，請返回微信繼續操作",
	"transSec.MarketplaceConfirmationOrderPagePaymentResultConfirmationPopUpWindow": "商城確認訂單頁_支付結果確認彈窗",
	"transSec.MallOrderConfirmationPageCouponRetentionPopUpWindowConfirmationButton": "商城訂單確認頁_優惠券挽留彈窗_確認按鈕",
	"transSec.AcceptAndUse": "收下並使用",
	"transSec.PickUpFailed": "領取失敗",
	"transSec.NoPaymentResultDetected": "沒有檢測到支付結果",
	"transSec.IfYouHaveAlreadyPaidPleaseClickRefreshToQueryTheResults": "若已經支付 請點擊刷新進行結果查詢",
	"transSec.Repayment": "重新支付",
	"transSec.MallCashierPagePaymentConfirmationPopUpconfirmButton": "商城收銀檯頁_支付確認彈窗_確認按鈕",
	"transSec.flushed": "刷新",
	"transSec.MallOrderConfirmationPagePaymentResultConfirmationPopUpWindowCloseButton": "商城訂單確認頁_支付結果確認彈窗_關閉按鈕",
	"transSec.divide": "分",
	"transSec.timeLimit": "期",
	"transSec.0HandlingFees": "0手續費",
	"transSec.Fee¥¥": "含手續費¥",
	"transSec.PerIssue": "/每期",
	"transSec.recommend": "推薦",
	"transSec.MarketplaceConfirmOrderPagecouponClick": "商城確認訂單頁_優惠券點擊",
	"transSec.PleaseConfirmThatYouHaveReadAndAgree": "請確認您已閱讀並同意",
	"transSec.UserServiceAgreement": "《使用者服務協定》",
	"transSec.OfferSelected": "已選優惠",
	"transSec.OffersAreAvailable": "有可用優惠",
	"transSec.NoOffersAvailable": "無可用優惠",
	"transSec.AfterPaymentYouNeedToComeBackToConfirmThePaymentResultToEnsureThatThePurchaseContentIsSmoothlyDistributed": "支付后需要回來確認支付結果，確保購買內容順利發放！",
	"transSec.PaymentAmount": "支付金額",
	"transSec.Coupons": "優惠券",
	"transSec.IHaveReadAndAgree": "已閱讀並同意",
	"transSec.GotIt": "知道了",
	"transSec.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "支付該訂單請在《叫叫》公眾號的訂單物流中進行支付",
	"transSec.RequestPaymentIn": "要求支付中...",
	"transSec.MarketplaceOrderConfirmationPagecouponClick": "商城訂單確認頁_優惠券點擊",
	"transSec.abandon": "放棄"
}